module.exports = __webpack_public_path__ + "img/8.22d1fc83.png";